import i18n from '@/i18n';

const localeMap: Record<string, string> = {
  es: 'es-ES',
  it: 'it-IT',
};

export function formatDate(
  dateStr: string | undefined,
  options?: Intl.DateTimeFormatOptions,
): string {
  const locale = localeMap[i18n.language] ?? 'es-ES';
  const date = dateStr ? new Date(dateStr) : new Date();
  return date.toLocaleDateString(locale, options ?? { day: 'numeric', month: 'long', year: 'numeric' });
}

export function formatDateShort(dateStr: string): string {
  return formatDate(dateStr, { day: 'numeric', month: 'short' });
}
